export enum SearchView {
    Navigation = 'navigation',
    Lecture = 'lecture',
}
